module.exports = __webpack_public_path__ + "images/arr-up-violet.svg?69b18f0a959e509c9811022b9e5f6fcb";